import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredPOs,
  selectPOLoading,
} from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { editPOData } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';

const { PO_ADD_EDIT } = MODAL_TYPES;

const POTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredPOs(state),
    isLoading: selectPOLoading(state),
  }));

  const handleViewClick = record => {
    dispatch(editPOData(record.poReceivingID));
    dispatch(showModal(PO_ADD_EDIT, record));
  };
  
  const columns = [
    {
      title: 'PO Number',
      dataIndex: 'poNumber',
      sorter: (a, b) => a.poNumber?.localeCompare(b.poNumber) || 0,
    },
    {
      title: 'Vendor/Customer',
      dataIndex: 'vendorName',
      sorter: (a, b) => a.vendorName?.localeCompare(b.vendorName) || 0,
    },
    {
      title: 'Actions',
      dataIndex: 'poReceivingID',
      key: 'actions',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" onClick={() => handleViewClick(record)}>
              <i data-feather="eye" className="feather-eye"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default POTable;

